import { createAccessControl } from 'better-auth/plugins/access'
import { defaultStatements, adminAc } from 'better-auth/plugins/admin/access'

const statement = {
    ...defaultStatements,
    device: ['create', 'read', 'update', 'delete', 'configure'],
    business: ['read', 'create', 'update', 'delete'],
    model: ['read', 'configure', 'delete'],
    update: ['create'],
    log: ['read'],
} as const

export const ac = createAccessControl(statement)

export const systemAdmin = ac.newRole({
    device: ['create', 'read', 'update', 'delete', 'configure'],
    business: ['read', 'create', 'update', 'delete'],
    model: ['read', 'configure', 'delete'],
    update: ['create'],
    log: ['read'],
    ...adminAc.statements,
})

export const businessAdmin = ac.newRole({
    device: ['create', 'read', 'update'],
    business: ['read'],
})

export const user = ac.newRole({
    device: ['read'],
})
